export const BRAND = {
  primary: '#115099',
  primaryLight: '#2A7AC4',
  primaryDark: '#0D4078',
  primaryDeep: '#0C3D72',
  accent: '#D4B970',
  accentDark: '#B89D4A',
  placeholder: '#9A9AA3',
  label: '#115099',
  inputBorder: '#E5E4DF',
  green: '#5C8A4E',
  heading: '#0E0E13',
  paragraph: '#5A5A62',
  paragraphGray: '#6B6B73',
  orange: '#D4B970',
  redButton: '#C44536',
  redText: '#B91C1C',
  darkBg: '#0A2D52',
  darkSurface: '#0E3D6E',
  cream: '#FBFAF5',
  warmWhite: '#FBFAF5',
  gradient: 'linear-gradient(135deg, #115099 0%, #2A7AC4 50%, #0D4078 100%)',
  gradientButton: '#115099',
  gradientButtonHover: '#0D4078',
  shadow: '0 8px 28px rgba(17, 80, 153, 0.32)',
  shadowHover: '0 12px 36px rgba(17, 80, 153, 0.42)',
} as const;

export const APP_NAME = 'indiastatpublications';
export const APP_NAME_MAIN = 'Betiyan';
export const APP_NAME_SUFFIX = 'By CS';

export const LOGO_PATH = '/logo.svg';
